import { applyOperator, createPubSub } from 'js/tools';

export default context => {
    const config = {
        exactChoiceEnabled: false
    };

    const dataExactChoiceEnabled = context.getAttribute('data-exact-choice-enabled');

    if (dataExactChoiceEnabled !== null) {
        config.exactChoiceEnabled = JSON.parse(dataExactChoiceEnabled);
    }

    const refs = {
        rangeFrom: {
            node: context.querySelectorAll(`.input-select`)[0],
            get select() {
                return this.node.querySelector('select');
            },
            get options() {
                return this.select.querySelectorAll('option');
            },
            get value() {
                return parseFloat(this.select.options[this.select.selectedIndex]?.value);
            }
        },
        rangeTo: {
            node: context.querySelectorAll(`.input-select`)[1],
            get select() {
                return this.node.querySelector('select');
            },
            get options() {
                return this.select.querySelectorAll('option');
            },
            get value() {
                return parseFloat(this.select.options[this.select.selectedIndex]?.value);
            }
        }
    };

    const pubsub = createPubSub();

    function toggleOptions(optionNodes, toggle) {
        [...optionNodes].forEach(optionNode => toggleOption(optionNode, toggle));
    }

    function toggleOption(optionNode, toggle) {
        optionNode.style.display = toggle ? 'inherit' : 'none';
    }

    function updateRangeOptions(ref, targetRef) {
        const optionNodes = refs[ref].options;
        const targetValue = refs[targetRef].value;

        if (Number(targetValue) !== targetValue) {
            toggleOptions(refs[ref].options, true);

            return;
        }

        const operators = {
            rangeFrom: ['>', '>='],
            rangeTo: ['<', '<=']
        };

        [...optionNodes].forEach(optionNode => {
            const operator = config.exactChoiceEnabled ? operators[ref][0] : operators[ref][1];
            const toggle = !optionNode.value || !applyOperator(operator, optionNode.value, targetValue);

            toggleOption(optionNode, toggle);
        });
    }

    function updateStateByData(dataset) {
        refs.rangeFrom.node.jsApi.populate(dataset.from.options);
        refs.rangeTo.node.jsApi.populate(dataset.to.options);
        updateRangeOptionsState();
    }

    function updateRangeOptionsState() {
        updateRangeOptions('rangeFrom', 'rangeTo');
        updateRangeOptions('rangeTo', 'rangeFrom');
        toggleRangeFilter(refs.rangeTo.node, refs.rangeFrom.node.jsApi.lastItemIsSelected());
        toggleRangeFilter(refs.rangeFrom.node, refs.rangeTo.node.jsApi.firstItemIsSelected());
    }

    function toggleRangeFilter(rangeNode, disable) {
        if (!rangeNode.jsApi.hasValue() && !config.exactChoiceEnabled && disable) {
            rangeNode.jsApi.disable();
        } else {
            rangeNode.jsApi.enable();
        }
    }

    updateRangeOptionsState();

    refs.rangeFrom.select.addEventListener('change', () => {
        updateRangeOptionsState();
        pubsub.publish('change');
    });

    refs.rangeTo.select.addEventListener('change', () => {
        updateRangeOptionsState();
        pubsub.publish('change');
    });

    return {
        updateStateByData,
        subscribe: pubsub.subscribe
    };
};
